import { render } from "./PerfermanceTop5Widget.vue?vue&type=template&id=2246fb58&scoped=true"
import script from "./PerfermanceTop5Widget.vue?vue&type=script&lang=js"
export * from "./PerfermanceTop5Widget.vue?vue&type=script&lang=js"

import "./PerfermanceTop5Widget.vue?vue&type=style&index=0&id=2246fb58&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2246fb58"],['__file',"src/containers/widget/components/PerfermanceTop5Widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2246fb58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2246fb58', __exports__)) {
    api.reload('2246fb58', __exports__)
  }
  
  module.hot.accept("./PerfermanceTop5Widget.vue?vue&type=template&id=2246fb58&scoped=true", () => {
    api.rerender('2246fb58', render)
  })

}


export default __exports__